const LINK_REGEX = /\[([^\]]+)\]\(([^)]+)\)/g;
const BULLET_REGEX = /^(\s*)-\s+(.*)$/;

// Convert a message string (possibly multi-line, with markdown-style links and
// optional `- ` bullet lines) into an array of VNodes suitable for $bvModal.msgBoxOk.
export function renderErrorBody(h, message) {
  const lines = String(message == null ? '' : message).split('\n').filter(line => line.length > 0);
  if (lines.length === 0) return [h('p', { class: 'mb-0' }, '')];

  const blocks = parseBlocks(lines);
  return blocks.map((block, i) => {
    const isLast = i === blocks.length - 1;
    const spacing = isLast ? 'mb-0' : 'mb-2';
    if (block.type === 'paragraph') {
      return h('p', { class: spacing }, lineToVNodes(h, block.text));
    }
    return h('ul', { class: `${spacing} pl-4` }, renderItems(h, block.items));
  });
}

function parseBlocks(lines) {
  const blocks = [];
  let i = 0;
  while (i < lines.length) {
    const m = BULLET_REGEX.exec(lines[i]);
    if (m) {
      const baseIndent = m[1].length;
      const { items, consumed } = parseList(lines, i, baseIndent);
      blocks.push({ type: 'list', items });
      i += consumed;
    } else {
      blocks.push({ type: 'paragraph', text: lines[i] });
      i += 1;
    }
  }
  return blocks;
}

function parseList(lines, start, expectedIndent) {
  const items = [];
  let i = start;
  while (i < lines.length) {
    const m = BULLET_REGEX.exec(lines[i]);
    if (!m) break;
    const indent = m[1].length;
    if (indent < expectedIndent) break;
    if (indent > expectedIndent) {
      if (items.length === 0) break;
      const { items: childItems, consumed } = parseList(lines, i, indent);
      items[items.length - 1].children = childItems;
      i += consumed;
      continue;
    }
    items.push({ text: m[2], children: [] });
    i += 1;
  }
  return { items, consumed: i - start };
}

function renderItems(h, items) {
  return items.map(item => {
    const children = lineToVNodes(h, item.text).slice();
    if (item.children && item.children.length) {
      children.push(h('ul', { class: 'pl-4' }, renderItems(h, item.children)));
    }
    return h('li', children);
  });
}

function lineToVNodes(h, line) {
  const parts = [];
  let lastIndex = 0;
  LINK_REGEX.lastIndex = 0;
  let match;
  while ((match = LINK_REGEX.exec(line)) !== null) {
    if (match.index > lastIndex) parts.push(line.slice(lastIndex, match.index));
    parts.push(h('a', { attrs: { href: match[2], target: '_blank', rel: 'noopener' } }, match[1]));
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < line.length) parts.push(line.slice(lastIndex));
  return parts.length ? parts : [line];
}
